/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import Button from '../elements/Button';

export default function BrandIcon() {
  return (
    <Button
      className="group inline-flex flex-col items-center"
      type="link"
      href="/"
    >
      {/* Logo text container */}
      <div
        className="relative inline-flex items-baseline select-none pb-4"
        style={{ letterSpacing: '0.05em' }}
      >
        <span
          className="text-2xl sm:text-3xl lg:text-[2rem] font-extrabold tracking-tight"
          style={{ color: '#333333' }}
        >
          FAJ
        </span>
        <span
          className="text-2xl sm:text-3xl lg:text-[2rem] font-extrabold tracking-tight breathe-sync"
          style={{ color: '#FF0000' }}
        >
          T
        </span>
        <span
          className="text-2xl sm:text-3xl lg:text-[2rem] font-extrabold tracking-tight"
          style={{ color: '#333333' }}
        >
          ECH
        </span>

      </div>
    </Button>
  );
}
